import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import { shouldUseOutboundList } from './outboundListUi';

const OutboundShipmentsPage = lazy(() => import('./OutboundShipmentsPage'));

/**
 * Outbound Shipments: admin, staff and sales get the redesigned list; anyone else the route admits
 * (warehouse) gets `fallback`, the page it rendered before. Customers have their own Shipments route.
 */
export default function OutboundShipmentsGate({ fallback, ...props }) {
  const user = useSelector(selectUser);
  if (!shouldUseOutboundList(user)) {
    return fallback;
  }
  return (
    <Suspense fallback={null}>
      <OutboundShipmentsPage {...props} />
    </Suspense>
  );
}
